/**
 * renderStepOutput — dispatches a step's structured output to its per-step
 * renderer. Each renderer reads `step.output` defensively and appends the
 * step's narrative markdown; unknown step keys fall back to the narrative alone.
 */

import type { ResumeStepData } from "../../../api/client";
import GapOutput from "./GapOutput";
import PlanOutput from "./PlanOutput";
import RewriteSummaryOutput from "./RewriteSummaryOutput";
import RewriteExperienceOutput from "./RewriteExperienceOutput";
import RewriteSkillsOutput from "./RewriteSkillsOutput";
import TargetOutput from "./TargetOutput";
import TrackOutput from "./TrackOutput";
import InterviewReadinessOutput from "./InterviewReadinessOutput";
import LessonMarkdown from "../../LessonMarkdown";

export function renderStepOutput(stepKey: string, step: ResumeStepData) {
  switch (stepKey) {
    case "gap_analysis": return <GapOutput step={step} />;
    case "prioritize_plan": return <PlanOutput step={step} />;
    case "rewrite_summary": return <RewriteSummaryOutput step={step} />;
    case "rewrite_experience": return <RewriteExperienceOutput step={step} />;
    case "rewrite_skills": return <RewriteSkillsOutput step={step} />;
    case "target_employer": return <TargetOutput step={step} />;
    case "track_monthly":
    case "track_quarterly": return <TrackOutput step={step} />;
    case "interview_readiness": return <InterviewReadinessOutput step={step} />;
    default: return <LessonMarkdown>{step.narrative_markdown ?? ""}</LessonMarkdown>;
  }
}
